import { render, staticRenderFns } from "./templateList.vue?vue&type=template&id=3494bb92&scoped=true&"
import script from "./templateList.vue?vue&type=script&lang=js&"
export * from "./templateList.vue?vue&type=script&lang=js&"
import style0 from "./templateList.vue?vue&type=style&index=0&id=3494bb92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3494bb92",
  null
  
)

export default component.exports